const o = {
  name: "Clock",
  dimensions: { width: 24, height: 24 },
  content: `
      <circle cx="11" cy="11.75" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
      <path d="M11 5.75V11.75L14 14.75" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  `
};
export {
  o as Clock
};
